const modal = {
  cancelButton: 'Descartar',
  confirmButton: 'Confirmar',
  confirmChange: {
    title: 'Confirmar cambio',
    body: '¿Estás seguro de que deseas realizar este cambio?',
    confirmButton: 'Confirmar',
    cancelButton: 'Cancelar',
    verificationPlaceholder: 'Introduce la frase de verificación',
  },
};

export default modal;
